var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalContainer',{attrs:{"title":_vm.title},on:{"close":function($event){return _vm.close()}}},[_c('DataGrid',{attrs:{"fields":_vm.dataGridFields,"data-retriever":this.getData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }